/* Panier RZT · version Shopify
   ---------------------------------------------------------------------------
   Le site statique portait un panier autonome en localStorage, avec un
   catalogue en dur et un tunnel qui s'arrêtait au récapitulatif faute de
   prestataire de paiement. Sur Shopify il n'y a plus rien à simuler : l'état
   vit dans le panier de la boutique, le paiement est celui de Shopify.

   Ce qui est repris tel quel du module d'origine : le tiroir, sa navigation au
   doigt (la barre masque ses liens sous 900 px), la fermeture au voile, au
   bouton ou par Échap, et le focus rendu à l'élément d'origine.            */
(function () {
  'use strict';

  /* Les quatre entrées de la barre. Toutes les pages du thème vivent sous des
     chemins Shopify fixes, les URL sont donc écrites en clair. */
  /* Les trois consommables sont dans la liste, en retrait sous « Le lactate ».
     Sans eux, quelqu'un qui vient racheter des bandelettes n'avait aucune porte
     au doigt : ni la barre, qui masque ses liens sous 900 px, ni le tiroir, qui
     ne portait que les quatre pages. C'est le rachat le plus courant.
     Ce sont les URL réelles de la boutique, relevées sur son sitemap. */
  var NAV = [
    { nom: 'Le lactate', url: '/pages/le-lactate' },
    { nom: 'Lecteur Fora X', url: '/products/lecteur-lactate-fora-x-10-bandelettes-100-autopiqueurs-v2', sous: 1 },
    { nom: 'Bandelettes', url: '/products/bandelettes-autopiqueurs', sous: 1 },
    { nom: 'Autopiqueurs', url: '/products/autopiqueurs-x100', sous: 1 },
    { nom: 'L’huile', url: '/products/recuperation-musculaire-nigelle-ultra-dosee' },
    { nom: 'Le journal', url: '/blogs/infos' },
    { nom: 'Structures', url: '/pages/structures' }
  ];

  var argent = function (centimes) {
    return (centimes / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ---- le tiroir, construit une fois -------------------------------- */
  var tiroir = document.createElement('div');
  tiroir.className = 'panier';
  tiroir.id = 'panier';
  tiroir.setAttribute('hidden', '');
  tiroir.innerHTML =
    '<div class="panier__voile" data-fermer></div>' +
    '<aside class="panier__vol" role="dialog" aria-modal="true" aria-labelledby="panier-titre">' +
      '<header class="panier__tete">' +
        '<p class="panier__titre" id="panier-titre">' +
          '<span class="panier__t--large">Votre panier</span>' +
          '<span class="panier__t--doigt">Menu</span>' +
        '</p>' +
        '<button class="panier__x" type="button" data-fermer aria-label="Fermer le panier">Fermer</button>' +
      '</header>' +
      '<div class="panier__defile">' +
      '<nav class="panier__nav" aria-label="Navigation principale">' +
        NAV.map(function (l) {
          return '<a class="panier__lien' + (l.sous ? ' panier__rayon' : '') +
                 '" href="' + l.url + '">' + l.nom + '</a>';
        }).join('') +
      '</nav>' +
      '<p class="panier__sous">Votre panier</p>' +
      '<div class="panier__corps" data-lignes></div>' +
      '</div>' +
      '<footer class="panier__pied">' +
        '<div class="panier__ligne-total"><span>Sous-total</span><strong class="num" data-total>0,00 €</strong></div>' +
        '<p class="panier__note">Expédition sous 48 h ouvrées · satisfait ou remboursé 30 jours, retours gratuits.</p>' +
        '<a class="btn btn--lg panier__cta" href="/checkout" data-commander>Passer commande</a>' +
      '</footer>' +
    '</aside>';
  document.body.appendChild(tiroir);

  var ici = location.pathname;
  Array.prototype.forEach.call(tiroir.querySelectorAll('.panier__lien'), function (a) {
    if (a.getAttribute('href') === ici) a.setAttribute('aria-current', 'page');
  });

  var boiteLignes = tiroir.querySelector('[data-lignes]');
  var champTotal = tiroir.querySelector('[data-total]');
  var boutonCmd = tiroir.querySelector('[data-commander]');
  var compteurs = document.querySelectorAll('[data-compteur]');

  function rendre(panier) {
    var n = panier.item_count || 0;
    Array.prototype.forEach.call(compteurs, function (c) {
      c.textContent = n;
      if (n === 0) { c.setAttribute('hidden', ''); } else { c.removeAttribute('hidden'); }
    });
    champTotal.textContent = argent(panier.total_price || 0);

    if (!n) {
      boiteLignes.innerHTML = '<p class="panier__vide">Votre panier est vide.<br>' +
        '<a class="lien" href="/pages/le-lactate">Le lecteur</a> · ' +
        '<a class="lien" href="/products/recuperation-musculaire-nigelle-ultra-dosee">l’huile</a></p>';
      boutonCmd.setAttribute('aria-disabled', 'true');
      boutonCmd.classList.add('is-off');
      return;
    }
    boutonCmd.removeAttribute('aria-disabled');
    boutonCmd.classList.remove('is-off');

    boiteLignes.innerHTML = panier.items.map(function (l, i) {
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      return '<div class="pline">' +
        (img ? '<a href="' + l.url + '"><img src="' + img + '" alt="" width="72" height="86" loading="lazy"></a>' : '<span></span>') +
        '<div>' +
          '<p class="pline__n">' + l.product_title + '</p>' +
          '<p class="pline__v">' + (l.variant_title || '') + '</p>' +
          '<div class="pline__bas">' +
            '<div class="qty" role="group" aria-label="Quantité">' +
              '<button class="qty__btn" type="button" data-moins="' + (i + 1) + '" aria-label="Retirer un exemplaire">−</button>' +
              '<span class="qty__n num">' + l.quantity + '</span>' +
              '<button class="qty__btn" type="button" data-plus-ligne="' + (i + 1) + '" aria-label="Ajouter un exemplaire">+</button>' +
            '</div>' +
            '<span class="num">' + argent(l.final_line_price) + '</span>' +
            '<button class="pline__x" type="button" data-retire="' + (i + 1) + '">Retirer</button>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function lire() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { rendre(p); return p; })
      .catch(function () { /* hors ligne : on laisse l'affichage en place */ });
  }

  function change(ligne, quantite) {
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: ligne, quantity: quantite })
    }).then(function (r) { return r.json(); }).then(rendre);
  }

  /* ---- ouverture et fermeture --------------------------------------- */
  var origine = null;
  function ouvre(depuis) {
    origine = depuis || document.activeElement;
    tiroir.removeAttribute('hidden');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { tiroir.classList.add('is-on'); });
    lire();
    var premier = tiroir.querySelector('.panier__lien, [data-fermer]');
    if (premier) premier.focus();
  }
  function ferme() {
    tiroir.classList.remove('is-on');
    document.documentElement.style.overflow = '';
    setTimeout(function () { tiroir.setAttribute('hidden', ''); }, 320);
    if (origine && origine.focus) origine.focus();
  }

  document.addEventListener('click', function (e) {
    var ouvreur = e.target.closest('[data-panier-ouvre]');
    if (ouvreur) { e.preventDefault(); ouvre(ouvreur); return; }
    if (e.target.closest('[data-fermer]')) { e.preventDefault(); ferme(); return; }

    var moins = e.target.closest('[data-moins]');
    var plusL = e.target.closest('[data-plus-ligne]');
    var retire = e.target.closest('[data-retire]');
    if (moins || plusL || retire) {
      e.preventDefault();
      var ligne = parseInt((moins || plusL || retire).getAttribute(
        moins ? 'data-moins' : plusL ? 'data-plus-ligne' : 'data-retire'), 10);
      lire().then(function (p) {
        if (!p) return;
        var q = p.items[ligne - 1] ? p.items[ligne - 1].quantity : 0;
        change(ligne, retire ? 0 : Math.max(0, Math.min(20, q + (plusL ? 1 : -1))));
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !tiroir.hasAttribute('hidden')) ferme();
  });

  /* ---- ajout depuis un formulaire produit, sans quitter la page ------ */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[action*="/cart/add"]');
    if (!f) return;
    e.preventDefault();
    var bouton = f.querySelector('[type="submit"]');
    if (bouton) bouton.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin', body: new FormData(f)
    }).then(function (r) { return r.json(); })
      .then(function () { ouvre(bouton); })
      .catch(function () { f.submit(); })
      .then(function () { if (bouton) bouton.disabled = false; });
  });

  /* le compteur de la barre est juste dès le premier rendu */
  lire();
})();
